import axiosClient from './client'

export const showCommunity = id => axiosClient().get(`/communities/${id}`)
export const exportDonations = ({ communityId, from, to }) => axiosClient().post(
  `/communities/${communityId}/donations/export`, { from, to }
)